import React, { useState } from "react";
import freeAd from "../images/sell-to-fw.png";
import biddingImg from "../images/formVector.png";
import DoneIcon from "@mui/icons-material/Done";
import { Box, Button, Modal } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import LoginModal from "../components/loginModal";
import SeoMeta from "../components/meta";
import NumberLogin from "../components/loginModal/number";
import InspectionHeaderImage from "../images/car-inspection-hero-image.png";
import BikeImage from "../images/CD70Black.png";

const Inspection = () => {
  const { user } = React.useContext(AuthContext);

  const history = useHistory();

  const navigateToBidding = () => {
    history.push("/sell-through-live-bidding");
  };

  const [isOpen, setIsOpen] = useState(false);

  const LoginOpen = () => {
    setIsOpen(true);
  };
  const LoginClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <SeoMeta
        title="Sell my car online | Famewheels"
        desc="Famewheels, a trusted platform in Pakistan, offers post-car ads. Sell your car online from anywhere with ease, and it connects you with potential buyers quickly."
        url="ad-category"
      />

      <div className=" colorBg_new d-none d-lg-block"></div>
      <div className="bg_post_category py-5">
        <h2 className="color-secondary fs-3 fw-600 text-center">
        Vehicle Inspection
        </h2>
        <h4 className=" text-black fw-normal text-center mt-4">
          Choose Which Inspection You Want
        </h4>

        <div className="container mb-3 mt-2">
          <div className="row justify-content-center">
            <div className="col-md-4 p-2 ">
              <div className="bg-white  boxShadow rounded-3 p-3 rounded adCards">
                <p className="fs-4 text-center fw-600 text-black">
                  Car Inspection
                </p>

                <div className="d-flex justify-content-center align-items-center flex-column mt-3">
                  <img
                    src={InspectionHeaderImage}
                    alt="post-free-ad"
                    className="img-fluid object-fit-contain w-50 rounded"
                  />

                  <ul className="mt-3 saleSteps p-0">
                    <li className="gap-2">
                      <DoneIcon color="error" /> On-site car inspections.
                    </li>
                    <li className="gap-2">
                      <DoneIcon color="error" /> Detailed condition reports.
                    </li>
                    <li className="gap-2">
                      <DoneIcon color="error" /> Reliable and convenient
                      service.
                    </li>
                  </ul>
                  <small className="smallText">
                    * Service available only in Karachi
                  </small>

                  <div className="w-75 mt-3">
                    {user ? (
                      <Link to="/car-inspection">
                        <Button
                          variant="contained"
                          fullWidth
                          className="bgSecondary text-white px-4 fw-normal text-capitalize fw-600"
                        >
                          Post Ad
                        </Button>
                      </Link>
                    ) : (
                      <Button
                        variant="conatined"
                        onClick={LoginOpen}
                        fullWidth
                        className="bgSecondary text-white px-4 mt-4 fw-normal text-capitalize fw-600"
                      >
                        Book Inspection
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 p-2">
              <div className="bg-white  boxShadow rounded-3 p-3 rounded adCards">
                <p className="fs-4 text-center fw-600 text-black">
                  Bike Inspection
                </p>

                <div className="d-flex justify-content-center align-items-center flex-column mt-3">
                  <img
                    src={BikeImage}
                    alt="post-free-ad"
                    className="img-fluid object-fit-contain w-50 rounded"
                  />

                  <ul className="mt-3 saleSteps p-0">
                    <li className="gap-2">
                      <DoneIcon color="error" /> On-site bike inspections.
                    </li>
                    <li className="gap-2">
                      <DoneIcon color="error" /> Comprehensive condition
                      reports.
                    </li>
                    <li className="gap-2">
                      <DoneIcon color="error" /> Fast, reliable, and convenient
                      service.
                    </li>
                  </ul>

                  <small className="smallText mb-2">
                    * Service available only in Karachi
                  </small>

                  <div className="w-75 mt-5">
                    {user ? (
                      <Link to="/bike-inspection">
                        <Button
                          variant="contained"
                          fullWidth
                          className="bgSecondary text-white px-4 py-2 fw-normal text-capitalize fw-600"
                        >
                          Sell For You
                        </Button>
                      </Link>
                    ) : (
                      <Button
                        variant="conatined"
                        onClick={LoginOpen}
                        fullWidth
                        className="bgSecondary text-white px-4 py-2 fw-normal text-capitalize fw-600"
                      >
                        Book Inspection
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={isOpen}
        onClose={LoginClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="sm-modal p-3 p-md-4">
          <div className="modalBody_area  px-2 ">
            <NumberLogin />
          </div>
        </Box>
      </Modal>
      {/* <LoginModal open={isOpen} onClose={LoginClose} /> */}
    </>
  );
};

export default Inspection;
